<!-- <mat-toolbar class="mat-elevation-z3">
</mat-toolbar> -->
@if(this.appStateService.isUserLoggedIn())
{
<mat-sidenav-container>
  <mat-sidenav opened mode="side" [style.width]="calculateWidth()">

    <div class="flex-container">
      <div>
        <button class="menu-button" mat-icon-button (click)="collapsed.set(!collapsed())">
          <mat-icon>menu</mat-icon>
        </button>
        <div class="sidenav-header">
          <img [width]="profilePicSize()" [height]="profilePicSize()"
            [attr.src]="'https://graph.microsoft.com/v1.0/me/photo/$value' | secureImg | async"
            [alt]="this.appStateService.account()?.name" />
          @if(!collapsed()) {
          <button mat-icon-button (click)="logout()">
            <mat-icon>logout</mat-icon>
          </button>
          <div class="header-text">
            <h2>{{this.appStateService.account()?.name}}</h2>
          </div>
          }
        </div>

        <mat-nav-list>
          <app-item icon="folder" route="request" translationKey="request.menuTitle" />
        </mat-nav-list>
      </div>
      <div>
      </div>
      <div>
        DEBUG
        <mat-nav-list>
          <app-item icon="group" route="profile" translationKey="profile.menuTitle" />
        </mat-nav-list>

        @if(!collapsed()) {
        <span class="version-text">{{ "app.version" | translate }}:<br/><span [innerHTML]="version()"></span></span>
        }
        @else
        {
        <span class="version-text" [innerHTML]="version()"></span>
        }
      </div>
    </div>

  </mat-sidenav>
  <mat-sidenav-content [style.margin-left]="calculateWidth()">
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
}@else {
<mat-card class="login-box">
  <p>{{"app.title" | translate}}</p>
  <img src="/AP_Logo_RGB_long_cobalt.png" alt="Allgeier Public"/>
  <button class="login-button" mat-flat-button (click)="login()">
    {{ "app.loginButton" | translate }}
    <mat-icon>login</mat-icon>
  </button>
</mat-card>
}